/**
 * @description 项目中使用的常量
 */
export default {
	/**
	 * @description 订货会设置
	 */
	// 往次订货数量是否显示
	see_old_order : {
		TRUE : 2,  // 显示
		FALSE : 1, // 不显示
	},
	/**
	 * @description 角色判断
	 */
	wap_role : {
		ADMIN : 'admin',	// 管理员
		PURCHASER : 'purchaser',	// 总代或采购商 -- 与 parent_id 结合判断是总代还是采购商
		SHOPER : 'shoper',	// 门店
	},
	parent_id : {
		TRUE : 0,	// 	当 wap_role.PURCHASER 且 parent_id 为 0 时 当前用户为总代。当 wap_role.PURCHASER 且 parent_id 不为 0 时 当前用户为采购商
	}
}


// WEBPACK FOOTER //
// ./src/common/constants.js